<template>
  <div :style="styles" class="rt-detail-aside">
    <slot />
    <div v-if="showMore" class="rt-detail-more">
      <div v-if="packUp" class="more-item" @click="packUpItems">
        <p>收起全部</p>
        <rt-icon name="rt-base-arrow_up"></rt-icon>
      </div>
      <div v-else class="more-item" @click="rollUpItems">
        <p>展开更多</p>
        <rt-icon name="rt-base-arrow_down"></rt-icon>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RtDetailAside',
  props: {
    showMore: {
      type: Boolean,
      default: false
    },
    maxItems: {
      type: Number,
      default: 3
    }
  },
  data() {
    return {
      packUp: false,
      items: [],
      movedItems: [],
      moved: false
    };
  },
  computed: {
    styles() {
      return {
        paddingBottom: this.showMore ? '40px' : '20px'
      };
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.items = this.$slots.default.filter(item => {
        return item.tag;
      });
      if (this.items.length > this.maxItems) {
        this.removeItems();
      }
    },
    removeItems() {
      let movedItems = [];
      this.items.forEach((item, index) => {
        if (index >= this.maxItems) {
          movedItems.push(item.elm);
          this.$el.removeChild(item.elm);
        }
      });
      this.movedItems = movedItems.slice();
      this.packUp = false;
    },
    packUpItems() {
      this.init();
    },
    rollUpItems() {
      this.movedItems.forEach(item => {
        this.$el.appendChild(item);
      });
      this.packUp = true;
    }
  }
};
</script>

<style lang="less">
.rt-detail-aside {
  padding: 20px 10px;
  background: #fff;
  position: relative;
}
.rt-detail-more {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  .more-item {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #a9c2e8;
    .rt-icon {
      line-height: 1;
      margin-left: 7px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// rtDetailAside.vue?1247bdb0